module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-Book.64be03fa.woff";